var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenomics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 300",
    style: {
      enableBackground: "new 0 0 300 300"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#65306A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.6,90H135c3.3,0,6-2.7,6-6s-2.7-6-6-6h-22.9C102,65.1,92.8,52.9,85.5,42H171c3.3,0,6-2.7,6-6s-2.7-6-6-6 H78c-5.7-9.8-9-18-9-24c0-3.3-2.7-6-6-6s-6,2.7-6,6c0,22.8,30.5,60.8,69.2,108.9c15,18.7,31.1,38.8,46.2,59.1H159 c-3.3,0-6,2.7-6,6s2.7,6,6,6h22c8.6,12.1,16.7,24.2,23.7,36H141c-3.3,0-6,2.7-6,6s2.7,6,6,6h70.6c6.8,12.5,12.2,24.7,15.5,36H219 h-24h-84c-3.3,0-6,2.7-6,6s2.7,6,6,6h84h24h10.9c0.7,4.1,1.1,8.1,1.1,12c0,3.3,2.7,6,6,6s6-2.7,6-6 c0-52.8-57.1-123.9-107.5-186.6C130.8,101.5,126.1,95.7,121.6,90z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171,258c3.3,0,6-2.7,6-6s-2.7-6-6-6H82.5c5.6-11.7,12.7-23.9,20.6-36.3c0.6,0.2,1.2,0.3,1.9,0.3h48 c3.3,0,6-2.7,6-6s-2.7-6-6-6h-42.2c10.7-16,22.5-32,34-47.4c2-2.6,1.5-6.4-1.2-8.4c-2.6-2-6.4-1.5-8.4,1.2 C97.4,193.9,57,251.3,57,294c0,3.3,2.7,6,6,6s6-2.7,6-6c0-10.9,3.1-23.1,8.2-36H171z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111,18h116.8c-4.3,9.8-12.7,22.2-23,36H195h-24h-36c-3.3,0-6,2.7-6,6s2.7,6,6,6h36h24h0.6 c-5.2,6.7-10.6,13.5-16.2,20.4c-7.2,9-14.7,18.4-22.2,28.2c-2,2.6-1.5,6.4,1.1,8.4c1.1,0.9,2.4,1.3,3.7,1.3 c1.8,0,3.6-0.8,4.8-2.3c7.5-9.7,15-19.1,22.1-28.1c30.3-38,54.2-68,54.2-87.9c0-3.3-2.7-6-6-6c-3.3,0-6,2.7-6,6c0,0,0,0,0,0H111 c-3.3,0-6,2.7-6,6S107.7,18,111,18z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenomics);
export default __webpack_public_path__ + "static/media/genomics.904f59d11b929ccbd6a3af4f020c509f.svg";
export { ForwardRef as ReactComponent };